import { z } from "zod";
import { type IntlShape } from "react-intl";

import { getPasswordSchema } from "./password";

export const getAuthenticationRequestSchema = (intl: IntlShape) =>
	z.object({
		username: z
			.string(
				intl.formatMessage({ id: "validation.username.invalid", defaultMessage: "Please enter a valid email address" }),
			)
			.trim()
			.min(
				1,
				intl.formatMessage({ id: "validation.username.empty", defaultMessage: "Please enter your email address" }),
			),
	});

export const getAuthenticationPasswordRequestSchema = (intl: IntlShape) =>
	z.object({
		username: z
			.string(
				intl.formatMessage({ id: "validation.username.invalid", defaultMessage: "Please enter a valid email address" }),
			)
			.trim()
			.min(
				1,
				intl.formatMessage({ id: "validation.username.empty", defaultMessage: "Please enter your email address" }),
			),
		password: z.string().trim().optional(),
	});

export const authenticationTokenRequestSchema = (intl: IntlShape) =>
	z.object({
		token: z
			.string()
			.trim()
			.nonempty(intl.formatMessage({ id: "validation.token.empty", defaultMessage: "Please supply your token" })),
	});

export const getPasswordResetVerifySchema = (intl: IntlShape) =>
	z.object({
		token: z
			.string()
			.trim()
			.length(
				6,
				intl.formatMessage({
					id: "validation.code.empty",
					defaultMessage: "Please enter the verification code",
				}),
			),
		email: z
			.string(
				intl.formatMessage({ id: "validation.username.invalid", defaultMessage: "Please enter a valid email address" }),
			)
			.trim()
			.min(
				1,
				intl.formatMessage({ id: "validation.username.empty", defaultMessage: "Please enter your email address" }),
			),
	});

export const getPasswordResetCompleteSchema = (intl: IntlShape) =>
	z.object({
		password: getPasswordSchema(intl),
	});

export const tokenResponseSchema = z.object({
	access_token: z.string(),
	token_type: z.string(),
	expires_in: z.number(),
});

export type AuthenticationRequestData = z.infer<ReturnType<typeof getAuthenticationRequestSchema>>;
export type AuthenticationPasswordRequestData = z.infer<ReturnType<typeof getAuthenticationPasswordRequestSchema>>;
export type AuthenticationTokenRequestData = z.infer<ReturnType<typeof authenticationTokenRequestSchema>>;
export type PasswordResetVerifyData = z.infer<ReturnType<typeof getPasswordResetVerifySchema>>;
export type PasswordResetCompleteData = z.infer<ReturnType<typeof getPasswordResetCompleteSchema>>;
export type TokenResponse = z.infer<typeof tokenResponseSchema>;
